module.exports = __webpack_public_path__ + "tv.741b9164af6d7acf0baf.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/tv.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/tv.svg
// module chunks = styles